import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'

export default class ScatteringAsh extends React.Component {
  resource = 'moen/health/scattering_ashes'
  form_key = 'scattering_ash'
  defaults = {}

  // Delete lines as needed
  fee = 99
  free = true
  postpaid = true
  skip_location = true
  hide_buttons = false
  custom_actions = []

  validate = null

  foremost = null

  fields = form => [
    {
      name: "approval_letter",
      label: "Written Approval Letter from Chief Medical Officer",
      type: "file:all",
      key: "image.0"
    },
    {
      name: "min_health",
      label: "Ministry of Health for the import of the ashes",
      type: "file:all",
      key: "image.1"
    },
    {
      name: "death_certificate",
      label: "Death Certificate",
      type: "file:all",
      key: "image.2"
    },
    {
      name: "cremation_certificate",
      label: "Cremation Certificate",
      type: "file:all",
      key: "image.3"
    },
    {
      name: "flight_info",
      label: "Flight Ticket Information",
      type: "file:all",
      key: "image.4"
    },
    {
      name: "location",
      type: "textarea"
    }

  ]

  render = () => <Wizard {...SERVICE_PROPS(this)} />
}

